export default __webpack_public_path__ + "static/media/arrow_left_gallery.b7fdc4bc.svg";